module.exports = __webpack_public_path__ + "static/media/boulangerie.97a1824d.svg";